module.exports = __webpack_public_path__ + "img/notify.968d8b7b.svg";